import CustomScreens from './customScreensStore';

export class CustomScreensStore {
  Stores = {
    customScreens: new CustomScreens(this),
  };
}

export default CustomScreensStore;
